import React, {Component} from "react";
import {request} from "../../../api-client";
import browserHistory from "../../../utils/browserHistory";
import * as VCS from "../../../components/Letflow/ContentCreatorViewComponents";
import localization from "../../../config/localization";
import GlobalAddToPlaylistDialog from "../../../components/Letflow/AddToPlaylistDialog/GlobalAddToPlaylistDialog";
import {
  checkIfMobile, GAevent,
  getAccessToken,
} from "../../../api-client/core/authentication/utils";
import styled from "styled-components";
import Logo from "../../../assets/img/logo-black.png";
import {Dialog, DialogActions, DialogContent, FormControl, Grid, MenuItem, Select} from "@material-ui/core";
import Contact from "../Contact/index.jsx"
import Button from "../../../components/CustomButtons/Button";
import {get} from "lodash"
import ShareOnSocials from "../../../components/Letflow/ShareOnSocials";
import ContentCreationPlayer from "../../../components/Letflow/ContentCreationPlayer";
import CreationItem from "../../../components/Letflow/CreationItem";

export default class AudiovisualCreator extends Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()

    this.state = {
      contentCreator: this.props.contentCreator,
      contentCreations: this.props.contentCreations || [],
      selectedContentCreation: this.props.selectedContentCreation,
      contentCreationsBySelectedTags: this.props.contentCreationsBySelectedTags || [],
      favorite: this.props.favorite || false,
      tags: this.props.tags || [],
      autoPlay: false,
      key: 0,
      currentIndex: null,
      showContactDialog: false,
      height: "175px",
      notAvailable: false,
      loaded: false,
      openDrmDialog: false,
      drmDialogOpened: false,
      trackedMainMaterialPlayed: false,
      showPreRoll: true,
      playedCreations: [],
      descriptionMaxWidth: '58%',
      shareToken: "",
      showContentCreationDialog: false,
      currentPlayingContent: {},
      availableFileTypes: this.getAvailableContentTypes(this.props.contentCreations),
      selectedFileType: "all",
      selectedTagId: "all"
    };
  }


  componentDidMount = () => {
    let description = document.getElementById("audiovisual-creator-description")
    let linkList = description ? (description.querySelectorAll('a') || []) : [];

    linkList.forEach((elem) => {
      elem.setAttribute('target', '_blank')
      elem.style.color = '#00b8d6'
      elem.style.fontWeight = 'bold'
    })

    this.state.contentCreations.length < 1 && this.setState({height: '100%', descriptionMaxWidth:'80%'});
  };

  componentDidUpdate = (prevProps) => {
    if(this.props.contentCreatorId !== prevProps.contentCreatorId) {
      this.props.contentCreations.length < 1 && this.setState({height: '100%'});
    }
  }

  componentWillReceiveProps = (nextProps, nextContext) => {
    if (this.state.contentCreations !== nextProps.contentCreations) {
      this.setState({contentCreations: nextProps.contentCreations});
    }
  }

  getTagsFromContentCreations = (contentCreations) => {
    let tags = [];
    contentCreations.forEach(contentCreation => {
      contentCreation.tags.forEach(tag => {
        !tags.find(t => t.id === tag.id) && tags.push(tag)
      })
    });
    return tags.sort((a, b) => a.name.localeCompare(b.name));
  };

  toggleFavorite = () => {
      this.setState({favorite: !this.state.favorite}, () => {
          GAevent('Contenido', "Favorite", this.state.contentCreator.name)
          request.contentCreatorFavorite[this.state.favorite ? 'add' : 'remove'](this.state.contentCreator.id)
      })
      this.props.modal && this.props.toggleModalFavorite && this.props.toggleModalFavorite()
  };

  getContentCreationType = (creation) => {
    let embededContent = creation.embededContent;
    if (creation.audio || (embededContent && (embededContent.source == 'spotify'))) {
      return 'audio';
    }
    if (creation.video || (embededContent && (embededContent.source == 'vimeo' || embededContent.source == 'youtube'))) {
      return "video";
    }
    if (creation.binary) {
      return 'binary';
    }
    if (creation.imageUrl) {
      return 'image';
    }
    return null;
  }

  getAvailableContentTypes = (creations) => {
    let creationTypes = creations
      .map(creation => this.getContentCreationType(creation))
      .filter(c => c != null);
    let filteredTypes = creationTypes.filter((c, index) => creationTypes.indexOf(c) == index);

    return [
      {id: "all", name: localization.get('all_creation_types')},
      {id: "video", name: localization.get('video')},
      {id: "audio", name: localization.get('audio')},
      {id: "image", name: localization.get('image')},
      {id: "binary", name: localization.get('others')},
    ].filter(item => item.id == 'all' || filteredTypes.indexOf(item.id) >= 0);
  }

  filterContentCreationsBySelectedTags = () => {
    let {contentCreations, selectedFileType, selectedTagId} = this.state;

    let contentCreationsBySelectedTags = contentCreations
      .filter(contentCreation => {
        let embededContent = get(contentCreation, 'embededContent', null);
        let hasVideo = get(contentCreation, 'video.url', false) || get(contentCreation, 'video.dash', false) || get(contentCreation, 'video.hls', false);
        let hasBinary = get(contentCreation, 'binary', false);
        let hasAudio = contentCreation.audio;
        let hasImage = get(contentCreation, 'imageUrl', false);
        if (selectedFileType == 'all') {
          return (hasAudio  ||
            hasBinary ||
            hasImage ||
            hasVideo ||
            embededContent)
        } else {
          return ((selectedFileType == 'audio' && hasAudio) ||
            (selectedFileType == 'binary' && hasBinary) ||
            (selectedFileType == 'image' && hasImage && !hasBinary && !hasVideo && !hasAudio && !embededContent) ||
            (selectedFileType == 'video' && hasVideo) ||
            (selectedFileType == 'video' && embededContent && (embededContent.source == 'vimeo' || embededContent.source == 'youtube')) ||
            (selectedFileType == 'audio' && embededContent && (embededContent.source == 'spotify'))
          )
        }
      });

    if (selectedTagId && selectedTagId != 'all') {
      const filterTags = contentCreation => contentCreation.tags.some(tag => tag.id === selectedTagId);

      contentCreationsBySelectedTags = contentCreationsBySelectedTags.filter(filterTags);
    }

    this.setState({contentCreationsBySelectedTags});
  }

  handleAddToPlaylistButtonPress = (data, type) => {
    GlobalAddToPlaylistDialog.show({
      type: type,
      contentCreatorType: type === 'contentCreator' && data.type.slug,
      selectedTrack: data,
      contentCreatorTagsIds: type === 'contentCreator' && this.getTagsFromContentCreations(this.state.contentCreations).map(tag => tag.id)
    });
  };

  renderShareDialog = () =>
      <ShareOnSocials
        show={this.state.showShareDialog}
        handleClose={() => this.setState({showShareDialog: false, isCreation: false, shareToken: false})}
        url={`${window.location.protocol}//${window.location.hostname}/public/${this.state.isCreation ? "content_creations" : "content_creators"}/${this.state.shareToken}`}
        darkMode={true}
        shareToken={this.state.shareToken}
      />

  renderContactDialog = () =>
    <Dialog open={this.state.showContactDialog} onBackdropClick={() => this.setState({showContactDialog: false})} maxWidth="false">
      <div style={{width: !checkIfMobile() ? 700 : "75vw"}}>
        <Contact
          modal={true}
          onSubmit={(name, email, description) => request.contentCreator.contact(this.state.contentCreator.id, name, email, description)}
          afterSubmit={() => this.setState({showContactDialog: false})}/>
      </div>
    </Dialog>

  //scroll = ()  => window.scrollTo(0, this.myRef.current.offsetTop + 175)
  scroll = ()  => document.getElementById('reference-scroll-position').scrollIntoView({
    block: "start",
    behavior: "smooth",
  })

  canPlayContent = (item) => {
    if (item.requireDrm && (/iPhone|iPad|iPod/i.test(navigator.userAgent) || window.safari !== undefined)) {
      !this.state.openDrmDialog && !this.state.drmDialogOpened && this.setState({openDrmDialog: true})
      return false
    }
    return true
  }

  renderDrmDialog = () =>
    <Dialog open={this.state.openDrmDialog} onBackdropClick={() => this.setState({openDrmDialog: false})}>
      <DialogContent style={{fontSize: 18}}>
        <p style={{paddingBottom: 5}}><b>{localization.get('no_drm_content.title')}</b></p>
        <p>{localization.get('no_drm_content.text')}</p>
      </DialogContent>
      <DialogActions style={{margin: "0 4% 4%"}}>
        <Button onClick={() => this.setState({openDrmDialog: false, drmDialogOpened: true})} color='default' style={{ backgroundColor: "black" }}>
          {localization.get("button.understood")}
        </Button>
      </DialogActions>
    </Dialog>


  onFavorite = (creation) => {
    if(!creation.favorite) {
      this.addToFavorites(creation.id)
    } else  {
      this.removeFromFavorites(creation.id)
    }
  }

  addToFavorites = id => {
    this.setState(state => ({
      ...state,
      contentCreationsBySelectedTags: state.contentCreationsBySelectedTags.map(creation => {
        if (creation.id === id) {
          return ({...creation, favorite: true})
        }
        return creation
      })
    }))
    request.contentCreationFavorite.add(id)
  }

  removeFromFavorites = id => {
    this.setState(state => ({
      ...state,
      contentCreationsBySelectedTags: state.contentCreationsBySelectedTags.map(creation => {
        if (creation.id === id) {
          return ({...creation, favorite: false})
        }
        return creation
      })
    }))

    request.contentCreationFavorite.remove(id)
  }

  clearCurrentPlayingContent = () => {
    this.setState({showContentCreationDialog: false, hasPrev: false, hasNext: false, currentIndex: null, currentPlayingContent: {}})
  }

  setCurrentPlayingContent = (index) => {
    let hasPrev = index > 0 ;
    let hasNext = index < (this.state.contentCreationsBySelectedTags.length - 1);
    this.setState({showContentCreationDialog: true, currentPlayingContent: this.state.contentCreationsBySelectedTags[index], hasPrev: hasPrev, hasNext: hasNext, currentIndex: index})
  }

  render = () => {
    let {contentCreator, contentCreations, favorite, tags, contentCreationsBySelectedTags, height } = this.state;
    contentCreationsBySelectedTags = (contentCreator.type.limit != null) ? contentCreationsBySelectedTags.slice(0, contentCreator.type.limit) : contentCreationsBySelectedTags
    const item = contentCreationsBySelectedTags[this.state.currentIndex];
    const key = contentCreationsBySelectedTags.findIndex(contentCreation => item && contentCreation.id === item.id);

    return (
      <React.Fragment>
        <ContentCreationPlayer
          show={this.state.showContentCreationDialog}
          isPublic={this.props.isPublic}
          noAuthorLink
          onNextArrow={this.state.hasNext ? () => this.setCurrentPlayingContent(this.state.currentIndex+1) : null}
          onPrevArrow={this.state.hasPrev ? () => this.setCurrentPlayingContent(this.state.currentIndex-1) : null}
          currentContentCreation={this.state.currentPlayingContent}
          handleClose={() => this.clearCurrentPlayingContent()}
        />
        <VCS.ViewContainer
          isPublic={this.props.isPublic}
          bgImage={this.state.contentCreator.coverImageUrl}>
          <VCS.TopContainer>
            {this.props.modal &&
              <div style={{
                left: this.state.width > 1200 && "66px",
                position: "absolute",
                float: "left",
                width: "auto",
                cursor: "pointer"
              }}>
                <div className="navbar-image-container-link" style={{top: '17px', left: 10,maxWidth: window.innerWidth < 769 ? "180px" : "auto"}} onClick={() => this.props.onModalClose()}>
                    <img
                      className="navbar-image"
                      style={{ maxWidth: "250px", filter: "invert(1)"}}
                      src={Logo}
                      alt={`Logo Bloomclouds`}/>
                </div>
              </div>
            }
            <VCS.TopContainerInfoContainer style={{maxWidth: '80%'}} InfoContainer>
              <VCS.TopContainerName style={{overflow: 'hidden', textOverflow: 'ellipsis'}} Name>
                {contentCreator.name}
              </VCS.TopContainerName>
              <CategoryName>{contentCreator.type.name}</CategoryName>

              {contentCreator.country &&
              <VCS.TopContainerCountry>{`${localization.get('nationality')}: ${contentCreator.country.name}`}</VCS.TopContainerCountry>}
              {contentCreator.residence && (contentCreator.residence.name != contentCreator.country.name) &&
              <VCS.TopContainerCountry>{`${localization.get('residence')}: ${contentCreator.residence.name}`}</VCS.TopContainerCountry>}
              {contentCreator.brand && contentCreator.brand.length > 0 && 
              <VCS.TopContainerCountry>{localization.get('creator.current_company', contentCreator.brand)}</VCS.TopContainerCountry>}
              {contentCreator.description &&
                <VCS.TopContainerDescription
                  text={contentCreator.description}
                  height={height}
                  onWidthChange={() => this.setState(prevState => ({...prevState, descriptionMaxWidth: prevState.descriptionMaxWidth === '58%' ? '80%' : '58%'}))}
                />
              }
            </VCS.TopContainerInfoContainer>
            <VCS.SocialBanner
              id={contentCreator.id}
              socialLinks={contentCreator.socialLinks}
              name={contentCreator.name}
              picture={contentCreator.imageUrl}
              blur={false}
              showFavoriteButton={!this.props.preview && !this.props.isPublic}
              showShareButton={!this.props.preview && !this.props.isPublic}
              showAddToPlaylistButton={!!getAccessToken()}
              favorite={favorite}
              onToggleFavorite={this.toggleFavorite}
              onAddToPlaylist={() => this.handleAddToPlaylistButtonPress(contentCreator, 'contentCreator')}
              onClose={() => !this.props.modal ? browserHistory.goBack() : this.props.onModalClose()}
              onShare={() =>
                request.contentCreator.share(contentCreator.id)
                  .then(response => this.setState({ showShareDialog: true, shareToken: response.code }))
              }
              showContact={this.state.contentCreator.email}
              onContact={() => this.setState({showContactDialog: true})}
              isPublic={this.props.isPublic}
            />
          </VCS.TopContainer>
          {(contentCreations.length > 0) &&
          <WorkContainer>
            <div style={{marginTop: 30, marginBottom: 30, display: "flex", alignItems: 'center', flexDirection: "row"}}>
              {(this.state.availableFileTypes.length > 2) &&
                <div style={{width: "300px", maxWidth: "50%", paddingLeft: 10, paddingRight: 10}}>
                  <FormControl style={{width: '100%'}}>
                    <Select
                      disableUnderline
                      value={this.state.selectedFileType}
                      style={{border: "1px solid #ccc", textAlign: "left", padding: "0 5%", color: "#6a6a6a", borderRadius: 20}}
                      onChange={(e) => this.setState({selectedFileType: e.target.value}, () => this.filterContentCreationsBySelectedTags())}
                    >
                      {this.state.availableFileTypes.map(fileType =>
                        <MenuItem value={fileType.id} style={{color: "#6a6a6a"}}>{fileType.name}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </div>
              }
              
              {(this.state.tags.length > 0 && contentCreations.length > 1) &&
                <div style={{width: "300px", maxWidth: "50%", paddingLeft: 10, paddingRight: 10}}>
                  <FormControl style={{width: '100%'}}>
                    <Select
                      disableUnderline
                      value={this.state.selectedTagId}
                      style={{border: "1px solid #ccc", textAlign: "left", padding: "0 5%", color: "#6a6a6a", borderRadius: 20}}
                      onChange={(e) => this.setState({selectedTagId: e.target.value}, () => this.filterContentCreationsBySelectedTags())}
                    >
                      <MenuItem value="all" style={{color: "#6a6a6a"}}>{localization.get("all_creation_tags")}</MenuItem>
                      {this.state.tags.map(tag =>
                        <MenuItem value={tag.id} style={{color: "#6a6a6a"}}>{tag.name}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </div>
              }
            </div>
            {contentCreationsBySelectedTags.length > 0 ?
              <Grid container>
                {contentCreationsBySelectedTags.map((creation, key) =>
                  <Grid key={key} xs={12} sm={6} md={4} lg={4} xl={4} item style={{padding: 10, width: "100%"}}>
                    <CreationItem
                      contentCreation={creation}
                      extraHeight
                      showDescription
                      hideAuthor
                      isPublic={this.props.isPublic}
                      onFavorite={() => this.onFavorite(creation)}
                      onPlay={() => this.setCurrentPlayingContent(key)}
                      onShare={id => request.contentCreation.share(id)
                        .then(response => this.setState({
                          showShareDialog: true,
                          shareToken: response.code,
                          isCreation: true,
                        }))
                      }
                    />
                  </Grid>
                )}
              </Grid>
              :
              <div style={{padding: 10, marginBottom: 40}}>{localization.get("no_creations_match")}</div>
            }
          </WorkContainer>
          }
        </VCS.ViewContainer>
        {this.renderShareDialog()}
        {this.renderContactDialog()}
        {this.renderDrmDialog()}
      </React.Fragment>
    );
  };
}


const AudioBar = styled.audio`
margin-top: 10px;
margin-bottom: 20px;
width:400px;
@media (max-width: 470px) {
  width: 80vw;
}
`;

const CarouselItem = styled.div`
  background-color: white;
  height: 0;
  overflow: hidden;
  padding-top: calc(591.44 / 1127.34 * 100%);
  position: relative;
  &:hover {
    box-shadow: 0 0 5px 0 dimgray;
  }
`

const WorkContainer = styled.section`
  //background-color: #ffffffc9;
  background-color: rgb(255, 255, 255);
  min-height: 100px;
  float: left;
  // border-bottom-left-radius: 30px;
  // border-bottom-right-radius: 30px;
  padding: 10px;
  width: 100%;
  @media (min-width: 479px) {
    padding: 10px 40px 40px 40px;
  }
`;


export const CategoryName =  styled.h4`
  flex: 1;
  margin-right: 10px;
  color: white;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 30px;
  @media (min-width: 600px) {
    font-size: 2em;
  }
`;